import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_prov_wrkrs_w_personal_prot_equipment_ppe_in_line_w'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_prov_wrkrs_w_personal_prot_equipment_ppe_in_line_w',
  name: 'Does the facility provide workers with Personal Protective Equipment (PPE) in line with legal requirements? ',
  description:
    'Personal protective clothing and equipment (PPE) should protect workers from the hazards identified in an assessment conducted at the factory. The employer must provide PPE when legally required, and when hazards cannot be eliminated or controlled at the source. \r\r\n\r\r\nPPE may be needed to protect workers from chemical, biological, physical or other hazards, including, e.g., hazardous substances, bodily injury, noise, air pollution, sharp objects, wet processes, eye injuries or burns.\r\r\n\r\r\nConsult applicable legal requirements. \r\r\n\r\r\nIf workers do not require PPE answer Not Applicable. ',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 4,
      slcpOptionName: 'ynna-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-31',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15700,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
